import React from 'react';
import {connect} from 'react-redux';
import Grid from '@material-ui/core/Grid';
import {Icon} from '@material-ui/core';
import {I18n} from 'react-redux-i18n';

import moment from '../../util/moment';

class DVRSnapshotsInfoMessage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lastUpdatedAt: null,
      isSnapshotsAvailable: true,
      isDvrOnline: true
    };
  }

  componentWillReceiveProps(nextProps) {
    const {isDvrOnline, isSnapshotsAvailable, snapshots} = nextProps;

    this.setState({
      isDvrOnline,
      isSnapshotsAvailable,
      lastUpdatedAt: snapshots.lastUpdatedAt
    });
  }

  handleDvrInfoMessage() {
    let dvrInfoMessage = null;

    if (this.state.lastUpdatedAt) {
      const lastUpdatedAt = moment(this.state.lastUpdatedAt).format(I18n.t('configuration.dateTimeFormat'));
      dvrInfoMessage = `${I18n.t('page.dvrsnapshots.dvrInfo.lastUpdatedAt')} ${lastUpdatedAt}`;
    } else if (this.state.isSnapshotsAvailable === false) {
      dvrInfoMessage = I18n.t('page.dvrsnapshots.dvrInfo.snapshotsNotAvailable');
    } else if (this.state.isDvrOnline === false) {
      dvrInfoMessage = I18n.t('page.dvrsnapshots.dvrInfo.dvrOffline');
    }

    if (dvrInfoMessage) {
      return (
        <div>
          <Grid
            item
            md={12}
            id={this.props.id}
            className="dvrcard__infocont"
          >
            <Icon className="dvrcard__info-icon">info</Icon>
            <span>{dvrInfoMessage}</span>
          </Grid>
        </div>
      );
    }

    return null;
  }

  render() {
    return (
      <div>{this.handleDvrInfoMessage()}</div>
    );
  }
}

const mapStateToProps = state => {
  const {dvrSnapshots} = state;

  return dvrSnapshots;
};

export default connect(mapStateToProps)(DVRSnapshotsInfoMessage);
